export default "__VITE_ASSET__DcgAMfb6__"